import { NetworkStatus } from "@apollo/client";

import { PollingIntervalGroups } from "apollo/constants";
import usePolledQuery from "apollo/usePolledQuery";
import { PublicWorkerPool } from "types/generated";

import { GET_PUBLIC_WORKER_POOL } from "./gql";

const useSearchPublicWorkerPool = () => {
  const { error, loading, data, networkStatus, previousData } = usePolledQuery<{
    publicWorkerPool: PublicWorkerPool;
  }>(GET_PUBLIC_WORKER_POOL, {
    pollingGroup: PollingIntervalGroups.SingleEntities,
  });

  return {
    publicWorkerPool: data?.publicWorkerPool || previousData?.publicWorkerPool,
    error,
    isPageLoading: loading && !data?.publicWorkerPool && networkStatus === NetworkStatus.loading,
  };
};

export default useSearchPublicWorkerPool;
